(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-swatch-finder"] && !Shopify.designMode) return;
  try {
    /* The following only works on first page loaded items
(async function() {
    document.querySelectorAll('.show-additional-swatches').forEach(e => {
        e.addEventListener('click', function() {
            document.querySelectorAll('.additional-swatches').forEach(f => {
                f.style.display = 'none';
            });
            document.querySelectorAll('.show-additional-swatches').forEach(g => {
                g.style.display = 'inline-block';
            });
            e.style.display = 'none';
            e.parentElement.querySelector('.additional-swatches').style.display='inline';
        });
    });
})();
*/
  } catch(e) { console.error(e); }
})();

})();
